import React from 'react';
import { useTheme } from '@mui/system';
import { Info as InfoIcon } from '@mui/icons-material';
import Tooltip from './Tooltip.js';
import i18n from '../localization/i18n.js';
import tokens from '../localization/tokens.js';

/**
 * 
 * @returns 
 */
const InfoTip = ({
  active
}) => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Tooltip, {
    tip: i18n.t(tokens.labels.changeRequests.extendedHealthCareDescription),
    arrow: true,
    placement: "top"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    "aria-label": "info",
    style: {
      marginTop: 4,
      color: active ? theme.palette.primary.light : theme.palette.primary.main
    }
  }));
};
export default InfoTip;